import React from "react";
import { PageHero } from "@/components/Shared";
import { Block } from "@/pages/PrivacyPolicy";
import { privacyMeta } from "@/pages/privacyPolicy";
import { charterMeta as M, charterSections } from "@/pages/charterContent";

function Toc() {
  return (
    <nav className="sticky top-28 bg-navy-paper border border-slate-800 p-5" data-testid="charter-toc">
      <div className="text-gold text-xs uppercase tracking-[0.3em] mb-4">Contents</div>
      <ol className="space-y-2 text-sm">
        {charterSections.map((s, i) => (
          <li key={s.id}><a href={`#${s.id}`} className="flex gap-2 text-slate-400 hover:text-gold transition-colors" data-testid={`charter-toc-${s.id}`}><span className="text-gold/70 w-5 text-right">{i + 1}.</span>{s.title}</a></li>
        ))}
      </ol>
    </nav>
  );
}

function ConductMeta() {
  return (
    <div className="mt-4 flex flex-wrap gap-x-8 gap-y-1 text-xs text-slate-400 uppercase tracking-widest" data-testid="conduct-meta">
      <span>Operated by <span className="text-white normal-case tracking-normal text-sm">{privacyMeta.operator}</span></span>
      <span>ABN <span className="text-white normal-case tracking-normal text-sm">{privacyMeta.abn}</span></span>
      <span>Effective <span className="text-white normal-case tracking-normal text-sm">{privacyMeta.effective}</span></span>
    </div>
  );
}

export default function MemberCharter() {
  return (
    <div data-testid="info-page-member-charter">
      <PageHero title={M.title} subtitle={M.subtitle} testId="info-hero-member-charter" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid lg:grid-cols-[260px_1fr] gap-12">
        <aside className="hidden lg:block"><Toc /></aside>
        <div className="max-w-3xl space-y-16">
          {charterSections.map((s, i) => (
            <section key={s.id} id={s.id} className="scroll-mt-28" data-testid={`charter-section-${s.id}`}>
              <div className="flex items-baseline gap-4 border-b border-gold/20 pb-3">
                <span className="font-display text-3xl font-bold text-gold/60">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="font-display text-2xl sm:text-3xl font-bold text-gold">{s.title}</h2>
              </div>
              {s.meta && <ConductMeta />}
              {s.blocks.map((b, j) => <Block key={j} b={b} />)}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
